export default __webpack_public_path__ + "static/media/svg-linkedin.eb11e5e7.svg";